/** @format */
import angular from 'angular';
import _ from 'lodash';
import { localDateFormatFilterModule } from '../date/filters/localDateFormat/localDateFormat.filter';
import { IconComponent } from '../icon/icon.component';
import courseUnitRealisationMessageTpl from './courseUnitRealisationMessage.tpl.html';

courseUnitRealisationMessageController.$inject = ['localeService'];

export const courseUnitRealisationMessageModule = 'sis-components.messenger.courseUnitRealisationMessage';

angular
    .module(courseUnitRealisationMessageModule, [localDateFormatFilterModule, IconComponent.downgrade.moduleName])
    .component('courseUnitRealisationMessage', {
        template: courseUnitRealisationMessageTpl,
        controller: courseUnitRealisationMessageController,
        bindings: {
            message: '<',
        },
    });

function courseUnitRealisationMessageController(localeService) {
    const $ctrl = this;

    $ctrl.supportedLocales = localeService.supportedLocales;

    if (!$ctrl.selectedLocale) {
        $ctrl.selectedLocale = $ctrl.supportedLocales[0];
    }

    $ctrl.selectLocale = locale => {
        $ctrl.selectedLocale = locale;
    };

    $ctrl.$onInit = () => {
        $ctrl.recipientsVisible = false;
        $ctrl.message.recipients = _.sortBy($ctrl.message.recipients, recipient => _.toLower(recipient.fullNameReversed));
    };
}
